import {matchDomain} from './matchDomain';

/**
 * @name matchDomains
 */
export const matchDomains = (
  url: string,
  domains: string[],
  allowSubdomains = true
): boolean =>
  !!domains.filter(domain => matchDomain(url, domain, allowSubdomains)).length;
